import { render, staticRenderFns } from "./PrestacionesList.vue?vue&type=template&id=451705a5&"
import script from "./PrestacionesList.vue?vue&type=script&lang=js&"
export * from "./PrestacionesList.vue?vue&type=script&lang=js&"
import style0 from "./PrestacionesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports